// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7148219","455":"386d2a0c","977":"869414d6"}[chunkId] + ".chunk.js";
};